export var OFACScreeningStatusEnum = /*#__PURE__*/ function(OFACScreeningStatusEnum) {
    OFACScreeningStatusEnum["DetailsNeeded"] = "DetailsNeeded";
    OFACScreeningStatusEnum["AwaitingDecision"] = "AwaitingDecision";
    OFACScreeningStatusEnum["Cleared"] = "Cleared";
    OFACScreeningStatusEnum["Flagged"] = "Flagged";
    return OFACScreeningStatusEnum;
}({});
